import { useEffect, useState } from 'react';

type Payload = {
    condition?: boolean;
    filePath: string;
};

export const useImportFile = ({ condition = true, filePath }: Payload) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [module, setModule] = useState<unknown | null>(null);

    useEffect(() => {
        if (condition) {
            import(filePath)
                .then((mod) => {
                    setModule(mod);
                })
                .catch((error) => {
                    console.error('Failed to load file:', error);
                })
                .finally(() => {
                    setIsLoaded(true);
                });
        }
    }, [condition, filePath]);

    return { loaded: isLoaded, module };
};
